import React from "react";
import { JobWithShare } from "@/lib/supabase/supabaseTypes";
import { cn } from "@/dentlab/src/lib/utils/cn";
import { usePatientStore } from "@/dentlab/src/store/Patient";
import { JobStatusEnum } from "@/lib/types/job";
import { Briefcase } from "lucide-react";
import { getStatusIcon, getStatusColor } from "@/dentlab/src/lib/utils/job-utils";

interface ClientJobPreviewListProps {
	jobs: JobWithShare[];
	onJobSelect?: (jobId: number) => void;
}

export const ClientJobPreviewList: React.FC<ClientJobPreviewListProps> = ({
	jobs,
	onJobSelect,
}) => {
	const { patientName, patientsLookup } = usePatientStore((state) => ({
		patientName: state.patientName,
		patientsLookup: state.patientsLookup,
	}));

	const handleJobClick = (job: JobWithShare) => {
		if (job.id) {
			onJobSelect?.(job.id);
		}
	};

	if (jobs.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center py-8 text-gray-400">
				<Briefcase size={32} className="mb-2" />
				<p className="text-sm">Keine Aufträge vorhanden</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col">
			{jobs.map((job) => {
				const patient = job.patient_id ? patientsLookup[job.patient_id] : null;

				return (
					<div
						key={job.id}
						onClick={() => handleJobClick(job)}
						className={cn(
							"flex items-center justify-between px-3 py-1.5 cursor-pointer transition-colors hover:bg-slate-200",
							"border-b border-white last:border-b-0"
						)}
					>
						<div className="flex items-center gap-2">
							<span className={cn(getStatusColor(job.status as JobStatusEnum))}>
								{getStatusIcon(job.status as JobStatusEnum)}
							</span>
							<span className="font-medium text-sm">{job.code}</span>
						</div>
						{patient && (
							<span className="text-xs text-gray-600">
								{patientName(patient)}
							</span>
						)}
					</div>
				);
			})}
		</div>
	);
};